<template>
  <div class="nav-footer-container">
      <div class="imgs">
        <img src="../assets/image/logo@2x.png" alt="竞争力">
        <div class="first">蓝天教育集团旗下个性化教育品牌</div>
        <div>十余年一对一个性化教育经验</div>
        <div>深耕本土学情考情</div>
        <div>服务深圳万千学子</div>
      </div>
      <div class="code">
        <img src="../assets/image/v2_qt4piy@2x.png" alt="">
        <p>扫码关注服务号</p>
      </div>
      <div class="code">
        <img src="../assets/image/v2_qt4plq@2x.png" alt="">
        <p>扫码关注视频号</p>
      </div>
      <div class="code">
        <img src="../assets/image/v2_qt4pj2@2x.png" alt="">
        <p>扫码关注资讯号</p>
      </div>
      <div class="concat-tel">
        <div class="rex">咨询热线：</div>
        <div class="tel"><img src="../assets/image/page4.png" alt="">0755-83521521</div>
        <div class="time">周一至周日：9:00-22:00</div>
        <div class="btn">在线咨询老师</div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryInfo:{
        currentNav: 1
      }
    }
  },
  methods:{
      goNav(num){
         this.queryInfo.currentNav = num
      }
  },
}
</script>


<style scoped lang="less">
  .nav-footer-container {
    width: 62%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0 auto;
    .imgs {
      width: 270px;
      img {
        width: 100%;
      }
      div {
        &.first {
          margin-top: 14px;
        }
        font-size: 16px;
        color: #fff;
        text-align: left;
        line-height: 28px;
      }
    }
    .code {
      font-size: 18px;
      color: #737479;
      img {
        width: 144px;
      }
      p {
        font-size: 16px;
        color: #fff;
        margin: 17px 0 0;
      }
    }
    .concat-tel {
      .rex {
        font-size: 25px;
        color: #fff;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .tel {
        font-size: 28px;
        color: #fff;
        font-weight: 500;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        img {
          width: 46px;
          margin-right: 10px;
        }
      }
      .time {
        font-size: 23px;
        font-weight: 300;
        color: #fff;
      }
      .btn {
        width: 167px;
        border-radius: 18.3px;
        line-height: 36.6px;
        text-align: center;
        font-size: 21px;
        font-weight: 500;
        color: #1361CF;
        background-color: #fff;
        margin: 24px 0 0 36px;
      }
    }
  }
</style>
